import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserDetailsForm from "../Component/UserDetailsForm";
import HeroBanner from "../Sections/HeroBanner";
import Payment from "../Component/Payment";
import CouponCodeInput from "../Component/CouponCodeInput";

const TransferBookingCustom = () => {
  const confirmTourNavigate = useNavigate();
  const location = useLocation();
  const total = location.state?.totalcharge;
  const bookingid = location.state?.bookingid;
 
    //console.log(bookingid + total);
   
  // //console.log("hh", bookingDetails, id);


  // const TotalPrice =
  //   bookingDetails?.net_price - data.Product_Header.promotion_discount_price < 0
  //     ? 0
  //     : bookingDetails?.net_price -
  //       data.Product_Header.promotion_discount_price;
  return (
    <>
      <div className="">
        <HeroBanner text={"Transfer"} imgUrl={"/assets/contact/hero-banner.png"} />
      </div>
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 mx-3 py-12">
          <div className="lg:w-[calc(70%-12px)]">
            {/* <UserDetailsForm /> */}
            <Payment id={bookingid} total={total}
            />
          </div>
        
        </div>
      </div>
    </>
  );
};

export default TransferBookingCustom;
